import { getDataClient } from "@/lib/dataClient";
import { useDataQuery } from "@/hooks/useDataQuery";

export interface Student {
  id: string;
  userId: string;
  name: string;
  email: string;
  grade: string;
}

/**
 * Sistemdeki tüm öğrencileri çeker (role = "ogrenci").
 * Öğretmen, canlı derse katılacak öğrencileri bu listeden seçer.
 */
export function useStudents() {
  return useDataQuery<Student[]>(async () => {
    const dataClient = getDataClient();
    const { data, error } = await dataClient
      .from("profiles")
      .select("id, user_id, full_name, email, grade")
      .eq("role", "ogrenci")
      .order("full_name", { ascending: true });
    if (error) throw error;
    return (data ?? []).map(
      (p: { id: string; user_id: string | null; full_name: string | null; email: string | null; grade: string | null }) => ({
        id: p.id,
        userId: p.user_id ?? p.id,
        name: p.full_name ?? p.email ?? "Öğrenci",
        email: p.email ?? "",
        grade: p.grade ?? "",
      }),
    );
  });
}